// extracted by mini-css-extract-plugin
export var actionText = "_n8-4";
export var container = "_n8-0";
export var leftSection = "_n8-1";
export var rightSection = "_n8-2";
export var settingsButton = "_n8-6";
export var settingsIcon = "_n8-7";
export var shortcut = "_n8-5";
export var shortcutGroup = "_n8-3";